import { supabase } from '@/lib/supabase'

export type AnalysisCourtesyEditor = {
  id: string
  fullName: string
  email: string
  avatarUrl: string | null
  role: string
  courtesyLimit: number
  courtesyUsed: number
  courtesyRemaining: number
}

export async function listAnalysisCourtesyEditors(): Promise<AnalysisCourtesyEditor[]> {
  const { data, error } = await supabase.rpc('list_analysis_editors_courtesy_status' as any)

  if (error) throw error

  const rows = Array.isArray(data) ? data : []

  return rows
    .map((row: any) => {
      const id = row?.user_id ? String(row.user_id) : ''
      if (!id) return null

      return {
        id,
        fullName: String(row?.full_name ?? '').trim(),
        email: String(row?.email ?? '').trim(),
        avatarUrl:
          typeof row?.avatar_url === 'string' || row?.avatar_url === null
            ? (row.avatar_url as string | null)
            : null,
        role: String(row?.role ?? '').trim(),
        courtesyLimit:
          row?.courtesy_limit != null ? Number(row.courtesy_limit) : 0,
        courtesyUsed:
          row?.courtesy_used != null ? Number(row.courtesy_used) : 0,
        courtesyRemaining:
          row?.courtesy_remaining != null
            ? Number(row.courtesy_remaining)
            : 0,
      }
    })
    .filter(Boolean) as AnalysisCourtesyEditor[]
}

export async function updateAnalysisCourtesyLimit(userId: string, limit: number): Promise<void> {
  const id = String(userId || '').trim()
  if (!id) return

  const nextLimit = Math.max(0, Math.floor(Number(limit)))

  const { error } = await supabase
    .from('analysis_editors')
    .update({ courtesy_limit: nextLimit })
    .eq('user_id', id)

  if (error) throw error
}
